module.exports = __webpack_public_path__ + "img/hook.5d019bc3.svg";